export type SendErrorResponse =
	| {
			id: string;
	  }
	| undefined;

export interface ErrorUtilityMethods<TRequest> {
	sendError(
		error: Error | unknown,
		userContext?: Record<string, unknown>,
	): Promise<SendErrorResponse>;
	sendErrorFromEndPoint(
		error: Error | unknown,
		request: TRequest,
		userContext?: Record<string, unknown>,
	): Promise<SendErrorResponse>;
}

export class WrappedError extends Error {
	readonly value: unknown;
	constructor(message: string, value: unknown) {
		super(message);

		this.value = value;
	}
}

export interface HttpRequest {
	url?: string;
	method?: string;
	path?: string;
	body?: unknown;
	query?: Record<string, unknown>;
	headers?: Record<string, unknown>;
}

export interface MappedHttpRequest {
	method: string | null;
	url: string | null;
	requestBody: unknown | null;
	query: Record<string, unknown> | null;
	headers: Record<string, unknown> | null;
}

export type ErrorDetails<
	T extends Record<string, unknown> = Record<string, unknown>,
> = {
	name: string;
	message: string;
} & T;

export type ErrorRequestContext = Record<string, unknown> | null;

export interface ErrorRequest<
	TDetails extends Record<string, unknown> = Record<string, unknown>,
> {
	errorName: string;
	errorDetails: ErrorDetails<TDetails>;
	stack: string | null;
	context: ErrorRequestContext;
	user: string;
	projectName: string;
}

export type AxiosErrorRequest = ErrorRequest<{
	url: string | null;
	query: Record<string, string | string[] | undefined> | null;
	params: unknown | null;
	method: string | null;
	statusCode: number;
	requestBody: unknown | null;
	responseBody: unknown | null;
}>;
